import { useEffect, useState } from 'react'
import { useCreateIncidentContext, useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks';
import { SquareButtonsCard } from '../molecules';
import styled from 'styled-components';
import { SimpleSupplierProps } from '@/custom-types';
import { SuppliersSimpleSelectionList } from './SuppliersSimpleSelectionList';
import PersonHouse from '@/assets/property-icons/person-ina-house-icon.svg'

const textsData = {
  en: {
    button1: 'Create Supplier',
    button2: 'Add Supplier',
    button3: 'No Supplier',
  },
  es: {
    button1: 'Crear Proveedor',
    button2: 'Agregar Supplier',
    button3: 'Sin Proveedor',
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 3rem;
`

export const SelectIncidentSupplierMenu = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const [selectedSupplier, setSelectedSupplier] = useState<SimpleSupplierProps | null>(null)
  const [isShowingSupplierList, setIsShowingSupplierList] = useState(false)

  const { createSupplierFormModalOpen } = useOpeningElementsControllerContext()

  const buttons = [
    { text: texts.button1, icon: PersonHouse },
    { text: texts.button2, icon: PersonHouse },
    { text: texts.button3, icon: PersonHouse },

  ];

  const { setSupplier, setButtonDisabled, setButtonEnabled } = useCreateIncidentContext()

  const onButtonActionHandle = (value: number | null) => {
    switch (value) {
      case null:
        return

      case 0:
        createSupplierFormModalOpen()
        break
      
      case 1:
        setIsShowingSupplierList(true)
        break

      case 2:
        setIsShowingSupplierList(false)
        setSelectedSupplier(null)
        setButtonEnabled()
        break

      default:
        throw new Error('On button action option is invalid [SelectPropertyOwnerMenu]')
    }
  }

  useEffect(() => {
    if (!selectedSupplier) {
      setButtonDisabled()
      return
    }
    setButtonEnabled()
    setSupplier(selectedSupplier)
  
  }, [selectedSupplier])

  useEffect(() => {
    setButtonDisabled()
  }, [])

  return (
    <Wrapper>
      <SquareButtonsCard
        buttons={buttons}
        onSelected={onButtonActionHandle}
      />
      {
        isShowingSupplierList
        ? <SuppliersSimpleSelectionList selected={(supplier) => setSelectedSupplier(supplier)}/>
        : null
      }
      
      
    </Wrapper>
  );
};
